import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Avatar from './Avatar';
import type { ChatSummary } from '../api/types';
import { backdropClose } from '../lib/modalBackdrop';

interface Props {
  chats: ChatSummary[];
  count: number;
  onClose: () => void;
  onForward: (chatIds: string[]) => void;
}

/** Выбор чата(ов) назначения для пересылки — только из уже имеющегося списка чатов пользователя. */
export default function ForwardModal({ chats, count, onClose, onForward }: Props) {
  const { t } = useTranslation('misc');
  const [selected, setSelected] = useState<Set<string>>(new Set());

  const toggle = (id: string) => {
    setSelected((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  };

  return (
    <div className="modal-backdrop" {...backdropClose(onClose)}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <h2>{t('forwardTitle', { count })}</h2>
        <div className="forward-chat-list">
          {chats.length === 0 && <div style={{ color: 'var(--muted)' }}>{t('forwardNoChats')}</div>}
          {chats.map((c) => (
            <div key={c.id} className="user-row" onClick={() => toggle(c.id)}>
              <Avatar
                userId={c.otherUserId}
                chatId={c.type === 2 || !c.otherUserId ? c.id : null}
                name={c.title || '?'}
                size={32}
                version={c.avatarFileId}
              />
              <div style={{ flex: 1 }}>{c.title || t('forwardChatFallback')}</div>
              <span className={'forward-check' + (selected.has(c.id) ? ' checked' : '')}>
                {selected.has(c.id) ? '✓' : ''}
              </span>
            </div>
          ))}
        </div>
        <div className="row" style={{ marginTop: 12, justifyContent: 'flex-end' }}>
          <button className="btn btn-ghost" onClick={onClose}>{t('forwardCancel')}</button>
          <button
            className="btn"
            disabled={selected.size === 0}
            onClick={() => onForward([...selected])}
          >
            {t('forwardAction')}{selected.size > 0 ? ` (${selected.size})` : ''}
          </button>
        </div>
      </div>
    </div>
  );
}
